import React from 'react';
import PropTypes from 'prop-types';
import './Question.scss';

const hideQuestionSubtext = (questionKey, onboarding) => onboarding && questionKey === 'education';

const hideQuestionText = (questionKey, onboarding) => {
  if (onboarding) {
    return ['education', 'functional_areas', 'therapeutic_areas'].includes(questionKey);
  }
  return false;
};

const designType = (questionKey, location) => {
  if (location === 'proposal-edit') return 'new-design proposal-edit';
  return 'new-design profile-edit';
};

function Question(props) {
  const {
    title,
    subtext,
    className,
    children,
    error,
    disabled,
    questionKey,
    isParent,
    location,
  } = props;

  const onboardingQuestionnaire = location === 'onboarding';
  const headerStyle = ['availability', 'available_when'].includes(questionKey) ? 'availability-header' : `header ${onboardingQuestionnaire ? 'onboarding-header' : 'profile-header'} mb-8`;
  const designTypeStyle = designType(questionKey, location);
  return (
    <div className={`question ${designTypeStyle} ${className} ${questionKey} ${disabled ? 'disabled-grey' : ''} ${isParent ? 'parent' : ''}`}>
      {error
        && (
        <div className="body-text-2 medium-weight with-error-text mb-2">
          <i className="fa fa-exclamation-triangle" />
          {' '}
          Required!
        </div>
        )}
      { hideQuestionText(questionKey, onboardingQuestionnaire) ? null
        : title
        && (
        <div className={`${headerStyle} ${error ? 'with-error-text' : ''}`}>
          { title }
        </div>
        )}
      { hideQuestionSubtext(questionKey, onboardingQuestionnaire) ? null
        : subtext
        && (
        <div className={`description subtext ${onboardingQuestionnaire ? 'onboarding-description' : ''}`}>
          {subtext}
        </div>
        )}
      { onboardingQuestionnaire && questionKey === 'location'
        ? (
          <div className="description">
            {' '}
            <strong>City or postal code</strong>
          </div>
        )
        : null}
      {children}
    </div>
  );
}

Question.propTypes = {
  title: PropTypes.string,
  subtext: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  questionKey: PropTypes.string,
  isParent: PropTypes.string,
  location: PropTypes.string,
};

Question.defaultProps = {
  title: null,
  subtext: null,
  className: '',
  children: null,
  error: false,
  disabled: false,
  location: 'onboarding',
  questionKey: '',
  isParent: false,
};

export default Question;
